export default __webpack_public_path__ + "media/styles/images/owi-icon-white-c15c1a569c424f964716748f3ef58da0.svg";